import React, { useCallback } from "react";
import { Typography } from "@mui/material";

import { colors } from "../../theme/palette";

import { CompareList } from "../../types";

import CompareRowText from "./CompareRowText";
import CompareRowFlag from "./CompareRowFlag";
import CompareRowBoolean from "./CompareRowBoolean";
import { useTranslation } from "react-i18next";

const AgentCompare = React.memo(({ compareUsersList }: { compareUsersList: any }) => {
  const { t } = useTranslation();

  const agentOverViewList: CompareList[] = [
    { label: t("components.compare.areasCovered"), key: "areasCovered", type: "text" },
    { label: t("components.compare.careerTransfersHandled"), key: "careerTransfersHandled", type: "text" },
  ];

  const nationalityAndLocationList: CompareList[] = [
    { label: t("components.compare.nationality"), key: "nationality", type: "flag" },
    { label: t("components.compare.country"), key: "country", type: "flag" },
  ];

  const professionalInfoList: CompareList[] = [
    { label: t("components.compare.footballExperience"), key: "footballExperience", type: "text" },
  ];

  const skillsList: CompareList[] = [{ label: t("components.compare.skills"), key: "skills", type: "text" }];

  const renderCompareRow = useCallback((item: CompareList, index: number, list: CompareList[]) => {
    const { label, key, type } = item;
    const totalRows: number = list.length;
    const isLastRow: boolean = index + 1 === totalRows;

    switch (type) {
      case "text":
        return <CompareRowText compareUsersList={compareUsersList} label={label} dataKey={key} isLastRow={isLastRow} />;
      case "flag":
        return <CompareRowFlag compareUsersList={compareUsersList} label={label} dataKey={key} isLastRow={isLastRow} />;
      case "boolean":
        return (
          <CompareRowBoolean compareUsersList={compareUsersList} label={label} dataKey={key} isLastRow={isLastRow} />
        );
      default:
        return null;
    }
  }, []);

  return (
    <>
      <Typography
        variant="body16Bold"
        sx={{
          borderRadius: "8px",
          background: colors.Gray50,
          padding: "8px 27px",
          fontWeight: 700,
          color: colors.Green100,
          display: "block",
        }}
      >
        {t("components.compare.agentOverview")}
      </Typography>
      {agentOverViewList.map(renderCompareRow)}
      <Typography
        variant="body16Bold"
        sx={{
          borderRadius: "8px",
          background: colors.Gray50,
          padding: "8px 27px",
          fontWeight: 700,
          color: colors.Green100,
          display: "block",
        }}
      >
        {t("components.compare.nationalityAndLocation")}
      </Typography>
      {nationalityAndLocationList.map(renderCompareRow)}
      <Typography
        variant="body16Bold"
        sx={{
          borderRadius: "8px",
          background: colors.Gray50,
          padding: "8px 27px",
          fontWeight: 700,
          color: colors.Green100,
          display: "block",
        }}
      >
        {t("components.compare.professionalCredential")}
      </Typography>
      {professionalInfoList.map(renderCompareRow)}
      <Typography
        variant="body16Bold"
        sx={{
          borderRadius: "8px",
          background: colors.Gray50,
          padding: "8px 27px",
          fontWeight: 700,
          color: colors.Green100,
          display: "block",
        }}
      >
        {t("components.compare.skills")}
      </Typography>
      {skillsList.map(renderCompareRow)}
    </>
  );
});

export default AgentCompare;
